import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

function news({ news }) {
  const shareUrl = "www.finnovex.com/finnovexlive/";
  return (
    <>
      <Container>
        <Row className="py-4">
          <Col lg={6}>
            <div className="owner">
              <div className="avatar-big text-center">
                <img
                  alt=""
                  className="img-no-padding img-responsive img-rounded pt-2"
                  src={require(`assets/images/news/${news.image}`)}
                  width={"400px"}
                />
              </div>
            </div>
          </Col>
          <Col lg={6} className="align-self-center mt-3 text-white">
            <h5 className="text-white">
              AI is fundamentally reshaping the financial industry by driving digital transformation
              and enhancing operational efficiency. Aligned with the business model and strategy of
              the bank, AI is reshaping and transforming key business capabilities and value streams
              to deliver significant strategic impact.
              <br />
              <br />
              Data governance establishes the authority and control needed to manage data as a
              strategic asset, ensuring it is handled securely, consistently, and in compliance with
              regulatory requirements. A well-structured data governance program ensures that data
              is properly managed, aligned with policies, and supports business objectives
              <br />
              <br />
              AI models can only be as effective as the quality, structure, and availability of data
              they rely on. Without robust data governance and principles, AI-driven banking
              solutions will struggle to deliver meaningful insights and automation. Also, banks
              often face challenges with legacy systems, fragmented data sources, and inconsistent
              data formats across departments, which hinder AI adoption. To address this, a
              centralized data governance framework is essential to standardize data collection,
              management, and integration across the enterprise.
              <br />
              <br />
              In this new paradigm, AI-driven algorithms make decisions at scale, ensuring speed,
              efficiency, and personalization, while human expertise is applied at the boundaries—to
              handle complex exceptions, ethical considerations, and long-term strategic direction.
              This shift positions AI as the engine of transformation, enabling banks to operate
              with agility, intelligence, and customer-centricity in a dynamic digital economy.
              <br />
              <br />
            </h5>
          </Col>
        </Row>

        <Row>
          <Col xs={1} className="d-none d-xl-block d-lg-block d-md-block"></Col>
          <FacebookShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                  marginLeft: "15px",
                }}
              >
                <span style={{ color: "#3b5998", display: "inline" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-facebook-square float-left" />
                </span>
              </Button>
            }
          />

          <LinkedinShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#0976b4" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-linkedin-square float-left" />
                </span>
              </Button>
            }
          />
          <TwitterShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                outline
                style={{
                  padding: 0,
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#55acee" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-twitter-square float-left" />
                </span>
              </Button>
            }
          />
        </Row>

        <Row>
          <Col className={"ml-auto mr-auto text-justify"} md="10">
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-AI is becoming a cornerstone of digital transformation in the banking industry.
                How is CIB leveraging AI to accelerate its digital transformation journey and
                enhance operational efficiency?
              </strong>
            </h5>

            <h5 className="text-white">
              AI is fundamentally reshaping the financial industry by driving digital transformation
              and enhancing operational efficiency. Aligned with the business model and strategy of
              the bank, AI is reshaping and transforming key business capabilities and value streams
              to deliver significant strategic impact.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Transformational projects often set new benchmarks for innovation. Can you share a
                key digital transformation project you've led at CIB and the impact it has made on
                the bank’s operations or customer experience?
              </strong>
            </h5>
            <h5 className="text-white">
              Originating and processing loans and credit facilities are core activities for banks,
              and executing them efficiently and effectively directly impact customer satisfaction,
              and top and bottom lines of the bank. Transforming this value streams requires
              understanding the customer needs and recommend the right products for the right
              customers through the right channels at the right time. Credit decisions should be
              automated through algorithms that use traditional and alternative data, decision
              engines and AI algorithms, and should be explainable to address regulatory concerns.
              Execution and disbursement should be swift and seamless.
            </h5>
            <br />
            <h5 className="text-white">
              <strong>
                Q-A strong enterprise architecture serves as the backbone of any digital
                transformation strategy. How does CIB’s enterprise architecture framework shape the
                bank's digital and AI-driven initiatives?
              </strong>
            </h5>
            <h5 className="text-white">
              Enterprise architecture framework is used as the bridge and line of sight from
              strategy to execution. Aligned with the business model and strategy, EA architecture
              is used to assess the key strategic business capabilities and value streams. It is
              used to sharp laser the exact building blocks to transform. It envisions the target
              enterprise architecture, and captures the as-is enterprise architecture. It builds the
              roadmap and interim enterprise architecture states to achieve the target architecture.
              It spans all the architecture domains of business, applications and systems, data
              engineering, data architecture, and data lineage, infrastructure and cloud, and
              solution architecture. Key digital services and AI use cases are identified to enable
              business capabilities. Enterprise architecture is developed in cycles, with each cycle
              has business objectives and visions. Within each cycle, enterprise architecture
              artefacts are developed and added to the repository, assessment and gap analysis is
              done, an architecture roadmap is developed, and a migration plan with digital and AI
              initiatives is detailed. The enterprise architecture uses the enterprise architecture
              governance framework to oversight the enterprise architecture execution.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Data is at the heart of every AI project, but its governance is equally critical.
                What role does data governance play in your AI initiatives, and how do you ensure
                data quality, privacy, and compliance?
              </strong>
            </h5>
            <h5 className="text-white">
              Data governance provide the authority and control over the management of data asset.
              The purpose of data governance is to ensure data is managed properly, according to
              policies and best practices. Data Governance focuses on how decisions are made about
              data and how people and processes are expected to behave. Data governance program
              includes, data and data governance strategy, policy related to data and metadata,
              setting and enforcing data quality and data architecture standards, provide oversight,
              audit, correction, and stewardship, Ensuring the organization can meet data-related
              regulatory compliance requirements, Issue management, and sponsor projects to improve
              data management practices. The data governance framework is composed of a data
              governance steering committee to provide funding for data governance and data
              governance-sponsored activities, data governance council to manage governance
              initiatives, data governance office, and stewardship teams.
              <br />
              <br />
              Data governance establishes the authority and control needed to manage data as a
              strategic asset, ensuring it is handled securely, consistently, and in compliance with
              regulatory requirements. A well-structured data governance program ensures that data
              is properly managed, aligned with policies, and supports business objectives.
              <br />
              <br />
              Key components of data governance include:
              <ul>
                <li>
                  Data Strategy & Policies – Defining clear guidelines for data management and
                  metadata governance.
                </li>
                <li>
                  Data Quality & Architecture Standards – Ensuring accuracy, consistency, and
                  integration across systems.
                </li>
                <li>
                  Regulatory Compliance & Risk Management – Meeting industry and legal requirements
                  for data handling.
                </li>
                <li>
                  Data Oversight & Stewardship – Monitoring, auditing, and enforcing governance best
                  practices.
                </li>
                <li>
                  Governance-Driven Initiatives – Sponsoring projects to improve data management
                  capabilities.
                </li>
              </ul>
              <br />
              To implement governance effectively, organizations rely on a structured framework
              comprising:
              <br />
              <ul>
                <li>Steering Committee – Provides funding and strategic direction.</li>
                <li>Governance Council – Manages governance initiatives and policy enforcement.</li>
                <li>Data Governance Office (DGO) – Oversees daily governance operations.</li>
                <li>Data Stewardship Teams – Ensure data integrity, quality, and compliance.</li>
              </ul>
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Your SAFe certification in Agile frameworks adds a unique dimension to your
                leadership style. How has this certification influenced your approach to digital and
                AI projects at CIB?
              </strong>
            </h5>
            <h5 className="text-white">
              Earning the SAFe SPC (SAFe Program Consultant) certification has empowered me to act
              as a change agent and subject matter expert (SME) in implementing enterprise and
              business agility at scale. This has enabled the creation of an Agile operating model
              alongside the organization's traditional hierarchical structure, ensuring adaptability
              and responsiveness at different levels.
              <br />
              <br />
              The Agile operating model is structured across multiple layers, from enterprise-level
              portfolios to solutions, value streams, Agile Release Trains (ARTs), and Agile teams.
              I played a pivotal role in defining digital and AI portfolios, ensuring alignment with
              strategic objectives. For each portfolio, I contributed to defining:
              <ul>
                <li>Lean Budgets for Agile Release Trains (ARTs) to optimize funding.</li>
                <li>Portfolio Vision and Objectives to drive long-term strategic outcomes.</li>
                <li>OKRs (Objectives & Key Results) aligned with value stream outcomes.</li>
                <li>Portfolio Kanban to manage the flow of initiatives efficiently.</li>
              </ul>
              <br />
              Additionally, I played a key role in identifying and mapping value streams, ensuring
              clear alignment between operating value streams (business execution) and development
              value streams (technology execution). I contributed by:
              <br />
              <ul>
                <li>
                  Mapping portfolio epics to solution capabilities, translating them into train
                  features and user stories to ensure strategic alignment.
                </li>
                <li>
                  Establishing prioritization frameworks and scoring models based on business goals.
                </li>
                <li>
                  Beyond execution, I have been instrumental in teaching and certifying
                  professionals in Agile methodologies, Portfolio Management, Agile Architecture,
                  and Product Management, fostering a culture of agility across the organization. My
                  expertise in SAFe has enabled me to drive scalable transformation, optimize
                  portfolio execution, and ensure continuous value delivery in a digital-first and
                  AI-driven enterprise.
                </li>
              </ul>
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Implementing AI in banking comes with its own set of challenges. What are the
                biggest obstacles you’ve encountered when deploying AI solutions, and how have you
                overcome them?
              </strong>
            </h5>
            <h5 className="text-white">
              AI models can only be as effective as the quality, structure, and availability of data
              they rely on. Without robust data governance and principles, AI-driven banking
              solutions will struggle to deliver meaningful insights and automation. Also, banks
              often face challenges with legacy systems, fragmented data sources, and inconsistent
              data formats across departments, which hinder AI adoption. To address this, a
              centralized data governance framework is essential to standardize data collection,
              management, and integration across the enterprise.
              <br />
              <br />
              Additionally, legacy systems are often incompatible with modern AI frameworks. To
              bridge this gap, banks must invest in API-based integrations and architectural
              modernization to ensure seamless data lineage, interoperability, and real-time data
              availability. By creating a scalable, AI-ready data infrastructure, banks can unlock
              the full potential of AI in driving business transformation and customer-centric
              innovation.
              <br />
              <br />
              In some cases, data limitations prevent AI models from capturing all possible
              scenarios. For instance, in algorithmic trading, historical data may not fully account
              for rare events such as liquidity crises and flash crashes. These extreme market
              conditions are unpredictable and may not have sufficient real-world occurrences to
              train AI models effectively.
              <br />
              <br />
              To address this challenge, banks can leverage synthetic data generation, AI-driven
              scenario simulations, and stress-testing frameworks to enhance model robustness. By
              incorporating what-if analysis and reinforcement learning, AI systems can better
              anticipate and respond to unprecedented market disruptions.
              <br />
              <br />
              For central banks and regulatory bodies, transparency, explainability, fairness, and
              unbiased decision-making are critical in AI-driven financial systems. To ensure
              regulatory compliance and ethical AI practices, banks must implement:
              <ul>
                <li>
                  Data Cleansing & Fairness-Aware Machine Learning – Detect and mitigate biases in
                  AI models to promote fairness in decision-making.{" "}
                </li>
                <li>
                  Representative Training Datasets – Ensure diverse and balanced datasets to prevent
                  skewed outcomes that could lead to discriminatory practices.
                </li>
                <li>
                  Regular AI Audits & Ethical Reviews – Continuously evaluate AI models to maintain
                  integrity, accountability, and compliance with evolving regulations.
                </li>
                <li>
                  Explainable AI (XAI) Models – Adopt AI frameworks that provide auditability,
                  interpretability, and regulatory clarity, making AI decisions more transparent.
                </li>
                <li>
                  Hybrid AI-Statistical Approaches – Augment traditional credit scoring models with
                  AI to enhance accuracy while maintaining regulatory compliance and
                  interpretability.
                </li>
              </ul>
              <br />
              Data protection and customer rights are critical challenges in AI-driven banking.
              Ensuring AI transparency is essential, providing customers with clear, understandable
              explanations of AI-driven decisions to build trust and regulatory compliance. To
              safeguard customers, banks must deploy AI-driven cybersecurity solutions for real-time
              fraud detection, anomaly monitoring, and risk mitigation. Additionally, AI penetration
              testing should be conducted regularly to identify and address vulnerabilities,
              ensuring robust protection against cyber threats and unauthorized access. By
              prioritizing security, transparency, and ethical AI practices, banks can enhance
              customer confidence and regulatory adherence in AI-powered financial services.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-As digital transformation accelerates, what advice would you offer to banking
                leaders on building a future-ready digital strategy that balances innovation,
                governance, and customer-centricity?
              </strong>
            </h5>
            <h5 className="text-white">
              Banking leaders must distinguish between leveraging emerging digital technologies and
              AI for simply automating the existing business model versus reimagining a new
              AI-driven, digitally enabled business model.
              <br />
              <br />A digitally enabled business model is adaptive, scalable, innovative, and
              customer-centric, moving beyond traditional product- or business unit-centric
              approaches. It is powered by a modernized digital operating model where AI is embedded
              at the core of decision-making, while humans focus on managing exceptions and
              strategic oversight.
              <br />
              <br />
              In this new paradigm, AI-driven algorithms make decisions at scale, ensuring speed,
              efficiency, and personalization, while human expertise is applied at the boundaries—to
              handle complex exceptions, ethical considerations, and long-term strategic direction.
              This shift positions AI as the engine of transformation, enabling banks to operate
              with agility, intelligence, and customer-centricity in a dynamic digital economy.
              <br />
              <br />
              To realize a digitally enabled business model, banking leaders must establish an
              adaptive framework that fosters innovation, experimentation, customer centricity, and
              agile product delivery. Traditional hierarchical structures often hinder innovation
              and create rigidity in execution. Therefore, a parallel framework dedicated to agility
              and innovation is essential.
              <br />
              <br />
              This transformation requires a new leadership approach—a lean-agile mindset—that
              embraces flexibility, rapid iteration, and value-driven decision-making. Leaders must
              drive change management initiatives, ensuring the organization shifts from a
              project-based mindset to a value stream-driven approach.
              <br />
              <br />
              An Enterprise Architecture framework plays a critical role in defining the change
              roadmap, identifying value streams, and structuring Agile Release Trains (ARTs). To
              support this evolution, banking leaders must establish a continuous delivery pipeline
              that enables seamless exploration, integration, and deployment of AI-driven solutions.
              By embedding agility at the core, banks can unlock faster innovation, operational
              efficiency, and customer-focused value creation.
              <br />
              <br />
              To enable data-driven capabilities and AI initiatives, banks must build a robust,
              scalable, and secure technology platform that serves as the foundation for AI-driven
              innovation. This platform should seamlessly integrate data infrastructure, AI/ML
              frameworks, computing resources, governance tools, and system integration capabilities
              to support AI at scale.
              <br />
              <br />
              When engaging with technology leaders, expect discussions around Data Lakes &
              Warehouses, Streaming Data Pipelines, AI/ML frameworks like TensorFlow, PyTorch, and
              Scikit-learn, MLOps for model deployment, Cloud AI services, and Edge AI. These
              components form the AI technology stack, requiring significant investment to ensure
              seamless AI adoption, real-time data processing, and enterprise-wide AI integration. A
              well-architected platform is not just a technology enabler—it is the backbone of an
              AI-first banking strategy.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-AI has the power to revolutionize customer interactions in banking. How is CIB
                utilizing AI-driven solutions to enhance customer experience and deliver more
                personalized banking services?
              </strong>
            </h5>
            <h5 className="text-white">
              AI is transforming customer experience, engagements, interactions, and services in
              banking by enabling new customer capabilities like hyper-personalization, immersive
              customer experience, intuitive customer journey, and embedded financial services.
              Banks are leveraging AI-powered solutions to enhance efficiency, deepen customer
              relationships, and deliver seamless, intelligent, and highly personalized banking
              experiences.
              <br />
              <br />
              Hyper-personalization is a more advanced form of personalization than traditional
              personalization. It goes beyond the traditional segmentation and targeting techniques.
              By leveraging real-time behavioral insights and predictive analytics, it enables
              personalized product recommendations, proactive customer support, and tailored content
              delivery, creating a highly contextual and relevant banking experience.
              <br />
              <br />
              Intuitive customer journey prioritizes simplicity, convenience, and ease of use,
              making it effortless for customers to access and manage their financial products and
              services. This is enabled through various AI capabilities like conversational bots and
              AI virtual assistance, AI enabled seamless authentication, budgeting analytics, and
              product recommendations. This requires design thinking, streamlined onboarding and
              omnichannel experience.
              <br />
              <br />
              Immersive customer experience that enables the customer to engage all five senses to
              create a more realistic and engaging experience. Customers feel fully engaged,
              empowered, and connected to the financial institution. AI-driven innovations such as
              voice authentication, and haptic feedback in mobile banking create a more engaging and
              responsive banking environment. AI-powered sentiment analysis further enhances
              customer support by adapting interactions based on real-time emotional insights.
            </h5>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default news;
